var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 3.3335H16.6665V8.3335H11.6665V3.3335Z",
    stroke: "#303C4A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 11.6665H8.3335V16.6665H3.3335V11.6665Z",
    stroke: "#303C4A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 14.1665C11.6665 14.8295 11.9299 15.4654 12.3987 15.9343C12.8676 16.4031 13.5035 16.6665 14.1665 16.6665C14.8295 16.6665 15.4654 16.4031 15.9343 15.9343C16.4031 15.4654 16.6665 14.8295 16.6665 14.1665C16.6665 13.5035 16.4031 12.8676 15.9343 12.3987C15.4654 11.9299 14.8295 11.6665 14.1665 11.6665C13.5035 11.6665 12.8676 11.9299 12.3987 12.3987C11.9299 12.8676 11.6665 13.5035 11.6665 14.1665Z",
    stroke: "#303C4A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 5.8335C3.3335 6.1618 3.39816 6.48689 3.5238 6.7902C3.64943 7.09352 3.83358 7.36912 4.06573 7.60126C4.29788 7.83341 4.57347 8.01756 4.87679 8.1432C5.1801 8.26883 5.50519 8.3335 5.8335 8.3335C6.1618 8.3335 6.48689 8.26883 6.7902 8.1432C7.09352 8.01756 7.36912 7.83341 7.60126 7.60126C7.83341 7.36912 8.01756 7.09352 8.1432 6.7902C8.26883 6.48689 8.3335 6.1618 8.3335 5.8335C8.3335 5.50519 8.26883 5.1801 8.1432 4.87679C8.01756 4.57347 7.83341 4.29788 7.60126 4.06573C7.36912 3.83358 7.09352 3.64943 6.7902 3.5238C6.48689 3.39816 6.1618 3.3335 5.8335 3.3335C5.50519 3.3335 5.1801 3.39816 4.87679 3.5238C4.57347 3.64943 4.29788 3.83358 4.06573 4.06573C3.83358 4.29788 3.64943 4.57347 3.5238 4.87679C3.39816 5.1801 3.3335 5.50519 3.3335 5.8335Z",
    stroke: "#303C4A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list-icon.63bae24d2c1c215adc7ced00b3890639.svg";
export { ForwardRef as ReactComponent };